import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
//---- Automatically generated, don't update this part ----

/**
 * A journal event representing the computation of a Kidney Failure Risk Equation for a patient
 */
export default class KfreTwoYearsComputedJournalEvent extends JournalEvent {
  static override type = "kfre-two-years-computed-journal-event";

  /**
   * The computed score in percentage
   */
  @attr("number") declare score: number;

  /**
   * The age of the patient when the score has been computed
   */
  @attr("number") declare age: number;

  /**
   * The last DFG CKD EPI when the score has been computed
   */
  @attr("number") declare dfg: number;

  /**
   * Albuminuria/Creatinuria ratio
   */
  @attr("number") declare rac: number;

  static override validations(intl: IntlService) {
    return {
      score: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.kfre-two-years-computed-journal-event.score"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.kfre-two-years-computed-journal-event.score"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.kfre-two-years-computed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      age: validateNumber({
        allowBlank: true,
        integer: true,
        description: intl.t(
          "validations.kfre-two-years-computed-journal-event.age"
        )
      }),
      dfg: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.kfre-two-years-computed-journal-event.dfg"
        )
      }),
      rac: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.kfre-two-years-computed-journal-event.rac"
        )
      })
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "kfreTwoYearsComputedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "kfre-two-years-computed-journal-event": KfreTwoYearsComputedJournalEvent;
  }
}
